
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Select as InputForm,
  SelectProps as ChakraInputProps,
} from '@chakra-ui/react';
import { forwardRef, ForwardRefRenderFunction } from 'react';
import { FieldError, Merge } from 'react-hook-form';

interface InputProps extends ChakraInputProps {
  name: string;
  options: { value: string; label: string }[];
  label?: string;
  error?: Merge<FieldError, undefined>;
}

const SelectBase: ForwardRefRenderFunction<HTMLSelectElement, InputProps> = (
  { name, label, error, isRequired, options ,...rest },
  ref,
) => {
  return (
    <FormControl isInvalid={!!error} isRequired={isRequired}>
      {!!label && (
        <FormLabel mt={'2'} htmlFor={name}>
          {label}
        </FormLabel>
      )}

      <InputForm
        name={name}
        id={name}
        borderRadius={'none'}
        focusBorderColor="purple.900"
        bgColor="white"
        variant="filled"
        borderColor={'black'}
        borderWidth={'0.125rem'}
        borderStyle="solid"
        size={'lg'}
        ref={ref}
        {...rest}
        height={'3.167rem'}
        maxWidth={'100%'}
        _hover={{
          backgroundColor: 'white',
          borderColor: 'black',
        }}
      >
        {options.map(opt => (
          <option value={opt.value}>{opt.label}</option>
        ))}
      </InputForm>

      {!!error && <FormErrorMessage data-test={`error-message-${error.ref?.name}`}>{error.message}</FormErrorMessage>}
    </FormControl>
  );
};

export const Select = forwardRef(SelectBase);